import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteStripeCards, setPaymentMethodSelection, updateStripePayableAmountAction } from "../../actions/stripe";
import { setFailedMessage } from "../../actions/message";
import { SUPPORTED_PAYMENT_METHOD, SUPPORTED_PAYMENT_METHOD_LIST } from "../../constants";
import DeleteCard from "./DeleteCard";
import AddNewCard from "./AddNewCard";

const CryptoIcon1 = () => (
  <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.12727 1.97083 0.598421 3.82031 0.504883L4 0.5Z" fill="white" />
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.12727 1.97083 0.598421 3.82031 0.504883L4 0.5Z" stroke="#EAECF0" />
    <g clipPath="url(#crypto-icon-1)">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.23619 3.36823L6.11808 7.92637C6.11002 7.94333 6.10747 7.96248 6.11079 7.98102C6.11412 7.99957 6.12315 8.01654 6.13656 8.02946L11.8571 13.6454C11.8733 13.6614 11.895 13.6703 11.9175 13.6703C11.94 13.6703 11.9616 13.6614 11.9779 13.6454L17.6984 8.02981C17.7118 8.01689 17.7208 7.99992 17.7242 7.98137C17.7275 7.96283 17.7249 7.94368 17.7169 7.92672L15.5988 3.36858C15.5919 3.35327 15.5809 3.3403 15.5671 3.33123C15.5533 3.32215 15.5372 3.31735 15.5207 3.31739H8.31491C8.2984 3.31718 8.28218 3.32187 8.26822 3.33089C8.25425 3.33991 8.24313 3.35288 8.23619 3.36823Z" fill="#50AF95" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12.6499 8.39404C12.6089 8.39719 12.3967 8.41017 11.9234 8.41017C11.5469 8.41017 11.2796 8.39859 11.1858 8.39404C9.73099 8.32847 8.64507 8.06901 8.64507 7.75835C8.64507 7.4477 9.73099 7.18858 11.1858 7.12196V8.13562C11.281 8.14264 11.5534 8.15912 11.9299 8.15912C12.3816 8.15912 12.6078 8.13983 12.6486 8.13598V7.12267C14.1003 7.18893 15.1839 7.4484 15.1839 7.75835C15.1839 8.0683 14.1007 8.32777 12.6486 8.39369L12.6499 8.39404ZM12.6499 7.01783V6.11076H14.676V4.72754H9.1598V6.11076H11.1855V7.01748C9.539 7.09497 8.30078 7.42911 8.30078 7.82953C8.30078 8.22994 9.539 8.56374 11.1855 8.64158V11.5483H12.6496V8.64053C14.2923 8.56304 15.5285 8.22924 15.5285 7.82918C15.5285 7.42911 14.2934 7.09532 12.6496 7.01748L12.6499 7.01783Z" fill="white" />
    </g>
    <defs><clipPath id="crypto-icon-1"><rect width="12" height="11" fill="white" transform="translate(6 3)" /></clipPath></defs>
  </svg>
);

const CryptoIcon2 = () => (
  <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
    <g clipPath="url(#crypto-icon-2)">
      <path d="M11.9088 14.1398C15.0382 14.1398 17.5558 11.6222 17.5558 8.49276C17.5558 5.36333 15.0382 2.8457 11.9088 2.8457C8.77935 2.8457 6.26172 5.36333 6.26172 8.49276C6.26172 11.6222 8.77935 14.1398 11.9088 14.1398Z" fill="#2775CA" />
      <path d="M13.4615 9.3874C13.4615 8.56389 12.9674 8.28153 11.9791 8.1639C11.2733 8.06977 11.1321 7.88155 11.1321 7.5521C11.1321 7.22265 11.3674 7.01094 11.838 7.01094C12.2615 7.01094 12.4968 7.15212 12.6144 7.50506C12.638 7.57565 12.7086 7.62269 12.7791 7.62269H13.1556C13.2497 7.62269 13.3203 7.5521 13.3203 7.45802V7.43447C13.2262 6.9168 12.8026 6.51682 12.2615 6.46978V5.90507C12.2615 5.81093 12.1909 5.74035 12.0733 5.7168H11.7203C11.6262 5.7168 11.5556 5.78739 11.5321 5.90507V6.44623C10.8262 6.54037 10.3792 7.01094 10.3792 7.59919C10.3792 8.37567 10.8497 8.68151 11.838 8.7992C12.4968 8.91683 12.7086 9.05801 12.7086 9.4345C12.7086 9.81099 12.3791 10.0698 11.9321 10.0698C11.3203 10.0698 11.1085 9.81093 11.038 9.45799C11.0145 9.36391 10.9439 9.31681 10.8733 9.31681H10.4733C10.3792 9.31681 10.3086 9.3874 10.3086 9.48154V9.50508C10.4027 10.0933 10.7792 10.5168 11.5556 10.6345V11.1992C11.5556 11.2933 11.6262 11.3639 11.7438 11.3874H12.0968C12.1909 11.3874 12.2615 11.3168 12.285 11.1992V10.6345C12.9909 10.5168 13.4615 10.0227 13.4615 9.3874Z" fill="white" />
      <path d="M10.7108 11.8578C8.87555 11.199 7.93436 9.15199 8.61675 7.34019C8.96969 6.35195 9.74616 5.59903 10.7108 5.24609C10.805 5.19905 10.852 5.12846 10.852 5.01077V4.68138C10.852 4.58724 10.805 4.51666 10.7108 4.49316C10.6873 4.49316 10.6403 4.49316 10.6167 4.51666C8.38143 5.22254 7.15788 7.59905 7.86377 9.83432C8.2873 11.152 9.29908 12.1637 10.6167 12.5873C10.7108 12.6343 10.805 12.5873 10.8285 12.4931C10.852 12.4696 10.852 12.4461 10.852 12.399V12.0696C10.852 11.999 10.7814 11.9049 10.7108 11.8578ZM13.205 4.51666C13.1108 4.46962 13.0167 4.51666 12.9932 4.61079C12.9697 4.63434 12.9697 4.65783 12.9697 4.70493V5.03432C12.9697 5.12846 13.0403 5.22254 13.1108 5.26963C14.9461 5.92842 15.8873 7.97548 15.2049 9.78728C14.852 10.7755 14.0755 11.5284 13.1108 11.8814C13.0167 11.9284 12.9697 11.999 12.9697 12.1167V12.4461C12.9697 12.5402 13.0167 12.6108 13.1108 12.6343C13.1344 12.6343 13.1814 12.6343 13.205 12.6108C15.4403 11.9049 16.6638 9.52842 15.9579 7.29315C15.5344 5.95197 14.4991 4.94019 13.205 4.51666Z" fill="white" />
    </g>
    <defs><clipPath id="crypto-icon-2"><rect width="12" height="12" fill="white" transform="translate(6 2.5)" /></clipPath></defs>
  </svg>
);

const CryptoIcon3 = () => (
  <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
    <g clipPath="url(#crypto-icon-3)">
      <path d="M15.7865 5.01843L15.457 5.34792C16.2432 6.2077 16.6792 7.33058 16.6792 8.49564C16.6792 9.6607 16.2432 10.7836 15.457 11.6434L15.7865 11.9729C16.6609 11.0244 17.1463 9.78174 17.1463 8.4918C17.1463 7.20185 16.6609 5.95914 15.7865 5.01074V5.01843Z" fill="#5A5564" />
      <path d="M8.85671 5.0467C9.71649 4.26048 10.8394 3.82449 12.0044 3.82449C13.1695 3.82449 14.2924 4.26048 15.1522 5.0467L15.4816 4.71721C14.5332 3.84285 13.2905 3.35742 12.0006 3.35742C10.7106 3.35742 9.46793 3.84285 8.51953 4.71721L8.85671 5.0467Z" fill="#5A5564" />
      <path d="M8.54865 11.6461C7.76337 10.7865 7.32794 9.66426 7.32794 8.49998C7.32794 7.33569 7.76337 6.21349 8.54865 5.3539L8.21916 5.02441C7.34481 5.97281 6.85938 7.21552 6.85938 8.50547C6.85938 9.79541 7.34481 11.0381 8.21916 11.9865L8.54865 11.6461Z" fill="#5A5564" />
      <path d="M15.1484 11.9512C14.2886 12.7374 13.1657 13.1734 12.0006 13.1734C10.8356 13.1734 9.71271 12.7374 8.85293 11.9512L8.52344 12.2807C9.47184 13.155 10.7145 13.6404 12.0045 13.6404C13.2944 13.6404 14.5371 13.155 15.4855 12.2807L15.1484 11.9512Z" fill="#5A5564" />
      <path d="M14.0793 7.40102C14.0134 6.71349 13.4203 6.48284 12.6702 6.41255V5.46582H12.0903V6.39498C11.9376 6.39498 11.7816 6.39498 11.6268 6.39498V5.46582H11.0513V6.41914H9.875V7.03968C9.875 7.03968 10.3033 7.03199 10.2967 7.03968C10.374 7.03118 10.4515 7.053 10.513 7.10053C10.5744 7.14806 10.615 7.2176 10.6262 7.29449V9.90404C10.6246 9.93116 10.6175 9.95767 10.6054 9.982C10.5934 10.0063 10.5765 10.028 10.5559 10.0457C10.5357 10.0638 10.5121 10.0776 10.4864 10.0862C10.4608 10.0949 10.4336 10.0983 10.4066 10.0962C10.4143 10.1028 9.98483 10.0962 9.98483 10.0962L9.875 10.7893H11.0403V11.758H11.6202V10.8035H12.0837V11.7536H12.6647V10.7959C13.6444 10.7366 14.3275 10.4949 14.4132 9.57785C14.4824 8.83979 14.1353 8.5103 13.5807 8.37741C13.9178 8.21156 14.1265 7.90404 14.0793 7.40102ZM13.2665 9.46362C13.2665 10.1841 12.0321 10.1017 11.6389 10.1017V8.82332C12.0321 8.82441 13.2665 8.71129 13.2665 9.46362ZM12.9975 7.66242C12.9975 8.32139 11.9673 8.24122 11.64 8.24122V7.07922C11.9673 7.07922 12.9975 6.97598 12.9975 7.66242Z" fill="#F09242" />
      <path d="M11.9989 14.5C10.8123 14.4998 9.65242 14.1477 8.6659 13.4884C7.67937 12.829 6.91051 11.8919 6.45652 10.7956C6.00253 9.69928 5.8838 8.49298 6.11534 7.32919C6.34689 6.16541 6.91831 5.09641 7.75736 4.25736C8.59641 3.41831 9.66541 2.84689 10.8292 2.61534C11.993 2.3838 13.1993 2.50253 14.2956 2.95652C15.3919 3.41051 16.329 4.17937 16.9884 5.1659C17.6477 6.15242 17.9998 7.31231 18 8.4989C18.0001 9.28702 17.845 10.0674 17.5435 10.7956C17.242 11.5237 16.7999 12.1854 16.2426 12.7426C15.6854 13.2999 15.0237 13.742 14.2956 14.0435C13.5674 14.345 12.787 14.5001 11.9989 14.5ZM11.9989 2.96788C10.9057 2.96875 9.83726 3.29369 8.92868 3.90164C8.02009 4.50958 7.31213 5.37324 6.89427 6.38345C6.47642 7.39366 6.36743 8.50507 6.58108 9.57721C6.79473 10.6494 7.32142 11.6341 8.0946 12.407C8.86778 13.1798 9.85272 13.7061 10.9249 13.9194C11.9972 14.1326 13.1085 14.0231 14.1186 13.6049C15.1286 13.1866 15.992 12.4783 16.5996 11.5695C17.2072 10.6607 17.5317 9.59212 17.5321 8.4989C17.5324 7.77229 17.3895 7.05275 17.1115 6.38142C16.8335 5.71009 16.4259 5.10015 15.912 4.58646C15.3981 4.07277 14.788 3.66541 14.1166 3.38768C13.4451 3.10995 12.7255 2.9673 11.9989 2.96788Z" fill="#282138" />
    </g>
    <defs><clipPath id="crypto-icon-3"><rect width="12" height="12" fill="white" transform="translate(6 2.5)" /></clipPath></defs>
  </svg>
);

const CryptoIcon4 = () => (
  <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
    <g clipPath="url(#crypto-icon-4)">
      <path d="M11.7812 2.5L11.7031 2.77346V10.7079L11.7812 10.7882L15.3527 8.61116L11.7812 2.5Z" fill="#343434" />
      <path d="M11.7786 2.5L8.20703 8.61116L11.7786 10.7882V6.93706V2.5Z" fill="#8C8C8C" />
      <path d="M11.7784 11.4855L11.7344 11.5408V14.3672L11.7784 14.4997L15.352 9.30957L11.7784 11.4855Z" fill="#3C3C3B" />
      <path d="M11.7786 14.4997V11.4855L8.20703 9.30957L11.7786 14.4997Z" fill="#8C8C8C" />
      <path d="M11.7812 10.7877L15.3527 8.61063L11.7812 6.93652V10.7877Z" fill="#141414" />
      <path d="M8.20703 8.61063L11.7786 10.7877V6.93652L8.20703 8.61063Z" fill="#393939" />
    </g>
    <defs><clipPath id="crypto-icon-4"><rect width="8" height="12" fill="white" transform="translate(8 2.5)" /></clipPath></defs>
  </svg>
);

const CryptoIcon5 = () => (
  <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" fill="white" />
    <path d="M4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V13C23.5 14.933 21.933 16.5 20 16.5H4C2.067 16.5 0.5 14.933 0.5 13V4C0.5 2.067 2.067 0.5 4 0.5Z" stroke="#EAECF0" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10.9504 2.57934C9.0835 2.90644 7.46317 4.12194 6.62765 5.82206C6.19172 6.70911 6 7.52663 6 8.49877C6 11.1196 7.62498 13.3862 10.1003 14.2184C10.7388 14.4331 11.2093 14.5013 12.0416 14.5C12.8546 14.4987 13.2454 14.4402 13.8978 14.2222C14.8649 13.8989 15.6253 13.4201 16.3281 12.6919C17.009 11.9863 17.4139 11.3194 17.7223 10.3963C17.9402 9.74363 17.9987 9.35265 18 8.53939C18.0013 7.70681 17.9331 7.23615 17.7185 6.59741C16.8805 4.10298 14.597 2.47904 11.9569 2.5002C11.6371 2.50276 11.1842 2.53837 10.9504 2.57934ZM14.2235 6.57565C14.101 6.92135 14.0007 7.21399 14.0007 7.22594C14.0007 7.2379 13.4944 7.2477 12.8756 7.2477H11.7505V7.54784V7.84797H12.7506C13.3764 7.84797 13.7506 7.86648 13.7506 7.89745C13.7506 7.92466 13.658 8.21729 13.5447 8.54774L13.3388 9.14856H11.9196H10.5004V7.54784V5.94711H12.4734H14.4464L14.2235 6.57565ZM11.035 10.4116L10.824 11.0244L10.2121 11.0385L9.60029 11.0525V10.4257V9.79885H10.4232H11.246L11.035 10.4116Z" fill="black" />
    <path d="M11.035 10.4116L10.824 11.0244L10.2121 11.0385L9.60029 11.0525V10.4257V9.79885H10.4232H11.246L11.035 10.4116Z" fill="#02EC81" />
    <path d="M14.2235 6.57565C14.101 6.92135 14.0007 7.21399 14.0007 7.22594C14.0007 7.2379 13.4944 7.2477 12.8756 7.2477H11.7505V7.54784V7.84797H12.7506C13.3764 7.84797 13.7506 7.86648 13.7506 7.89745C13.7506 7.92466 13.658 8.21729 13.5447 8.54774L13.3388 9.14856H11.9196H10.5004V7.54784V5.94711H12.4734H14.4464L14.2235 6.57565Z" fill="white" />
  </svg>
);

const CryptoBrandIcons = () => (
  <div className="paymentMethodBrandIcons" aria-hidden="true">
    <CryptoIcon1 />
    <CryptoIcon2 />
    <CryptoIcon3 />
    <CryptoIcon4 />
    <CryptoIcon5 />
  </div>
);

const SelectPayment = forwardRef(({ setAddCardLoader, isAdvisor }, ref) => {
  const cardRef = React.useRef(null);

  useImperativeHandle(ref, () => ({
    submitCard: () => {
      return cardRef.current?.handleSaveCard();
    },
  }));

  const { stripePlans, paymentMethodSelection } = useSelector(state => state.stripe);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [isDeleteCard, setIsDeleteCard] = useState(false);
  const isBankTransferAllowed = ['usd', 'sgd'].includes(stripePlans?.currency?.value?.toLowerCase());
  const selectPaymentMethod = (item) => {
    if (item === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER && !isBankTransferAllowed) {
      dispatch(setFailedMessage('Bank transfer is only available for USD and SGD.'));
      return;
    }

    dispatch(updateStripePayableAmountAction(0));
    dispatch(setPaymentMethodSelection(item));
  };

  useEffect(() => {
    if (!paymentMethodSelection) {
      dispatch(updateStripePayableAmountAction(0));
      dispatch(setPaymentMethodSelection(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD));
    }
  }, [dispatch, paymentMethodSelection]);

  const handleDelete = async () => {
    if (cardId) {
      setLoader(true)
      await dispatch(deleteStripeCards(cardId));
      setLoader(false)
      setIsDeleteCard(false)
      setCardId(null)
    }
  };

  const paymentMethodDetails = {
    [SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD]: {
      icon: "assets/img/cardIcon.svg",
      title: "Pay with card",
      description: "Pay securely using your saved or new card.",
    },
    [SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER]: {
      icon: "assets/img/bankIcon.svg",
      title: "Bank transfer",
      description: isBankTransferAllowed ? "Continue with bank transfer." : "Bank transfer is only available for USD and SGD.",
    },
    [SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO]: {
      icon: "assets/img/cryptoIcon.svg",
      title: "Pay with crypto",
      description: "Powered by FOMO pay",
    },
    [SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW]: {
      icon: "assets/img/paynow.svg",
      title: "PayNow",
      description: "Powered by FOMO pay",
    },
  };

  const renderMethodCard = method => {
    const details = paymentMethodDetails[method.value];
    const isSelected = paymentMethodSelection === method.value;
    const isDisabled = method.value === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER && !isBankTransferAllowed;

    if (!details) return null;

    return (
      <div
        key={method.value}
        onClick={() => !isDisabled && selectPaymentMethod(method.value)}
        className={`cardBackgroundSection ${isSelected ? "cardDetailsSectionActive" : ""} ${isDisabled ? "paymentMethodDisabled" : ""}`}
      >
        <div className="cardDetailsSection">
          <div className="leftCardSection">
            <div className="LeftCardDetails">
              <img src={details.icon} alt="" />
              <div className="LeftCardDetailsInner">
                <div className="nameHolder">
                  <h3 className="m-0">{details.title}</h3>
                  <p className="m-0">{details.description}</p>
                </div>
                {method.value === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO && <CryptoBrandIcons />}
              </div>
            </div>
          </div>
          <input
            type="checkbox"
            readOnly
            checked={isSelected}
            disabled={isDisabled}
            className="paymentMethodCheckbox"
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="container p-2">
        <DeleteCard
          isOpen={isDeleteCard}
          onHide={() => setIsDeleteCard(false)}
          deleteCardFunc={handleDelete}
          loader={loader}
        />
        <div className="buyProductSectionBgPayout">
          <div className="">
            <p className="m-0 selectPaymentTitle">
              Choose your preferred payment method
            </p>

            <div
              onClick={() => selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD)}
              className={`cardBackgroundSection ${paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ? "cardDetailsSectionActive" : ""}`}
            >
              <div className="paymentMethodExistingCard">
                <div className="addCardSection">
                  <AddNewCard
                    ref={cardRef}
                    setAddCardLoader={setAddCardLoader}
                    isAdvisor={isAdvisor}
                    selected={paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD}
                    onSelect={() => selectPaymentMethod(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD)}
                  />
                </div>
              </div>
            </div>

            {SUPPORTED_PAYMENT_METHOD_LIST
              .filter(method => method.value !== SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD)
              .map(renderMethodCard)}

            {/* <div className="cardBackgroundSection m-0">
              <div className="cardDetailsSection">
                <div className="leftCardSection">
                  <div className="LeftCardDetails">
                    <img src="assets/img/paidUpCapital.svg" alt="" />
                    <div className="LeftCardDetailsInner">
                      <div clssName="nameHolder">
                        <h3 className="m-0">Paid-up Capital</h3>
                        <p className="m-0">Coming soon</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <svg
                    width="8"
                    height="14"
                    viewBox="0 0 8 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L7 7L1 13"
                      stroke="#3B3B3B"
                      stroke-width="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
});

export default SelectPayment;
